import { Root } from './Pill.styles';
export default Root;